const numberFormatter = new Intl.NumberFormat("en-US");
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});
const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});
const shortDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
});
const shortDateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export function formatNumber(value) {
  return numberFormatter.format(value);
}

export function formatCurrency(value) {
  return currencyFormatter.format(value);
}

export function formatPercent(value) {
  return percentFormatter.format(value);
}

export function formatDelta(value) {
  const sign = value > 0 ? "+" : "";
  return `${sign}${value}`;
}

export function formatShortDate(value) {
  if (!value) return "N/A";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return shortDateFormatter.format(date);
}

export function formatShortDateTime(value) {
  if (!value) return "N/A";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return shortDateTimeFormatter.format(date);
}

export function formatDateRange(start, end) {
  return `${formatShortDate(start)} to ${formatShortDate(end)}`;
}

export function maskKey(value, visibleSuffix = 4) {
  const suffix = value.slice(-visibleSuffix);
  return `${"•".repeat(Math.max(0, value.length - visibleSuffix))}${suffix}`;
}
